import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";

ChartJS.register(...registerables);

const StackedBarChart = ({ data, year }: { data: any; year: String[] }) => {
  const yearRange =
    year.length > 1
      ? `${year[0]} - ${year[year.length - 1]}`
      : year[0].toString();
  const options = {
    maintainAspectRatio: false,
    type: "bar",
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    elements: {
      arc: {
        spacing: 0.5,
      },
    },
    plugins: {
      legend: {
        position: "bottom" as
          | "right"
          | "top"
          | "bottom"
          | "left"
          | "center"
          | "chartArea"
          | undefined,
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          boxHeight: 8,
          font: {
            size: 12,
            weight: 600 as const,
            family: "Inter",
          },
          color: "#101828",
          textAlign: "left" as const,
          padding: 20,
          pointStyle: "circle",
          radius: 2, // Decrease the radius as needed
        },
      },
      tooltip: {
        enabled: true,
        position: "nearest" as "nearest",
        backgroundColor: "#FFFFFF",
        titleColor: "#101828",
        titleFont: {
          size: 14,
          weight: 600 as const,
          family: "Inter",
        },
        bodyColor: "#101828",
        boxPadding: 4,
        bodyFont: {
          size: 12,
          weight: 500 as const,
          family: "Inter",
        },
        padding: 10,
        cornerRadius: 6,
        borderColor: "#EAECF0",
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        grid: {
          color: "#F2F4F7",
        },
        ticks: {
          color: "#667085",
          font: {
            size: 12,
            weight: 400 as const,
            family: "Inter",
          },
        },
      },
      y: {
        stacked: true,
        grid: {
          color: "#F2F4F7",
        },
        ticks: {
          padding: 10,
          color: "#667085",
          font: {
            size: 12,
            weight: 400 as const,
            family: "Inter",
          },
        },
      },
      x2: {
        labels: [yearRange],
        ticks: {
          color: "#101828",
          font: {
            size: 12,
            weight: 600 as const,
            family: "Inter",
          },
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  // Add borderWidth to each dataset in the data object
  data.datasets.forEach((dataset: any) => {
    dataset.borderWidth = 2; // You can adjust the border width as needed
  });
  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

export default StackedBarChart;
